import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function SecureFileImage({ alt, className, fileId, testId }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let active = true;
    if (!fileId) return undefined;
    api
      .post(`/files/${fileId}/signed-url`)
      .then(({ data }) => {
        if (active) setUrl(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      })
      .catch(() => active && setUrl(null));
    return () => {
      active = false;
    };
  }, [fileId]);

  if (!url) return null;
  return <img src={url} alt={alt} className={className} data-testid={testId} />;
}
